import React from "react";
import { FaWhatsapp } from 'react-icons/fa';
import { FaPhone } from 'react-icons/fa';
import "./Contact.css";
import Container from "../Container";

const Contact = () => {
  return (
    <Container>
      <section className="contact">
        <div className="contact-info">
          <div className="contact-title">Contáctanos y Agende su Cita</div>
          <div className="contact-address">
            <div className="contact-address-street">
              75 metros al Norte de la Terminal de Buses de Tracopa.
            </div>

            <div className="contact-address-email">
              Correo electrónico:{" "}
              <a href="mailto:gerencia@clinicastudiovisualcr.com">
                gerencia@clinicastudiovisualcr.com
              </a>
            </div>
          </div>

          <div className="contact-number">
            Agende su cita al:{" "}
            <a href="tel:+50622214181" className="phone-link" title="Llamar">
              <FaPhone size={18} /> 2221-4181
            </a>
          </div>
          <div className="whatsapp-button">
            <a
              href="https://wa.me/50687218585?text=Hola!%20Vengo%20del%20sitio%20web%20y%20me%20gustar%C3%ADa%20agendar%20una%20cita"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp size={20} />
              Enviar mensaje por WhatsApp
            </a>
          </div>
        </div>
        <div className="contact-picture">
          <img alt="contact" src={require("../../assets/contactpic.webp")} />
        </div>
      </section>
    </Container>
  );
};

export default Contact;
